<nb-card class="card-scroll">
	<nb-card-header class="header">
		<h4>
			<ngx-header-title>
				{{ 'MENU.TIMESHEETS' | translate }}
			</ngx-header-title>
		</h4>
	</nb-card-header>
	<nb-card-body>
		<nb-route-tabset [tabs]="tabs"></nb-route-tabset>
	</nb-card-body>
</nb-card>
